import _ from 'lodash';
import mediaQueryListFactory from '../common/media-query-list';
import {CartPreviewEvents} from './cart-preview';

const PLUGIN_KEY = {
    CAMEL: 'mobileMenuToggle',
    SNAKE: 'mobile-menu-toggle',
};

function optionsFromData($element) {
    const mobileMenuId = $element.data(PLUGIN_KEY.CAMEL);

    return {
        menuSelector: mobileMenuId && `#${mobileMenuId}`,
    };
}

/*
 * Manage the behaviour of a mobile menu
 * @param {jQuery} $toggle
 * @param {Object} [options]
 * @param {Object} [options.headerSelector]
 * @param {Object} [options.menuSelector]
 * @param {Object} [options.scrollViewSelector]
 */
export class MobileMenuToggle {
    constructor(
        $toggle,
        {
            headerSelector = '.header',
            menuSelector = '#menu',
            scrollViewSelector = '.navPages',
        } = {},
    ) {
        this.$body = $('body');
        this.$menu = $(menuSelector);
        this.$navList = $('.navPages-list.navPages-list-depth-max');
        this.$header = $(headerSelector);
        this.$scrollView = $(scrollViewSelector, this.$menu);
        this.$subMenus = this.$navList.find('.navPages-action');
        this.$toggle = $toggle;
        this.mediumMediaQueryList = mediaQueryListFactory('medium');

        // Auto-bind
        this.onToggleClick = this.onToggleClick.bind(this);
        this.onCartPreviewOpen = this.onCartPreviewOpen.bind(this);
        this.onMediumMediaQueryMatch = this.onMediumMediaQueryMatch.bind(this);
        this.onSubMenuClick = this.onSubMenuClick.bind(this);

        // Listen
        this.bindEvents();

        // Assign DOM attributes
        this.$toggle.attr('aria-controls', this.$menu.attr('id'));

        // Hide by default
        this.hide();
    }

    get isOpen() {
        return this.$menu.hasClass('is-open');
    }

    bindEvents() {
        this.$toggle.on('click', this.onToggleClick);
        this.$header.on(CartPreviewEvents.open, this.onCartPreviewOpen);
        this.$subMenus.on('click', this.onSubMenuClick);

        if (
            this.mediumMediaQueryList &&
            this.mediumMediaQueryList.addListener
        ) {
            this.mediumMediaQueryList.addListener(this.onMediumMediaQueryMatch);
        }
    }

    unbindEvents() {
        this.$toggle.off('click', this.onToggleClick);
        this.$header.off(CartPreviewEvents.open, this.onCartPreviewOpen);

        if (
            this.mediumMediaQueryList &&
            this.mediumMediaQueryList.addListener
        ) {
            this.mediumMediaQueryList.removeListener(
                this.onMediumMediaQueryMatch,
            );
        }
    }

    toggle() {
        if (this.isOpen) {
            this.hide();
            document.getElementById('backDrop').classList.add('hidden');
        } else {
            this.show();
            document.getElementById('backDrop').classList.remove('hidden');
        }
    }

    show() {
        this.$body.addClass('has-activeNavPages');

        this.$toggle.addClass('is-open').attr('aria-expanded', true);

        this.$menu.addClass('is-open');

        this.$header.addClass('is-open');
        this.$scrollView.scrollTop(0);

        this.resetSubMenus();
    }

    hide() {
        this.$body.removeClass('has-activeNavPages');

        this.$toggle.removeClass('is-open').attr('aria-expanded', false);

        this.$menu.removeClass('is-open');

        this.$header.removeClass('is-open');

        this.resetSubMenus();
    }

    // Private
    onToggleClick(event) {
        event.preventDefault();

        this.toggle();
    }

    onCartPreviewOpen() {
        if (this.isOpen) {
            this.hide();
        }
    }

    onMediumMediaQueryMatch(media) {
        if (!media.matches) {
            return;
        }

        this.hide();
    }

    onSubMenuClick(event) {
        const $closestAction = $(event.target).closest('.navPages-action');
        const $parentSiblings = $closestAction.parent().siblings();
        const $parentAction = $closestAction
            .closest('.navPage-subMenu-horizontal')
            .siblings('.navPages-action');

        if (this.$subMenus.hasClass('is-open')) {
            this.$navList.addClass('subMenu-is-open');
        } else {
            this.$navList.removeClass('subMenu-is-open');
        }

        if ($(event.target).hasClass('is-open')) {
            $parentSiblings.addClass('is-hidden');
            $parentAction.addClass('is-hidden');
        } else {
            $parentSiblings.removeClass('is-hidden');
            $parentAction.removeClass('is-hidden');
        }
    }

    resetSubMenus() {
        this.$navList.find('.is-hidden').removeClass('is-hidden');
        this.$navList.removeClass('subMenu-is-open');
    }
}

const closeMainMenu = document.querySelectorAll('.closeMainMenu');

for (let i = 0; i < closeMainMenu.length; i++) {
    closeMainMenu[i].addEventListener('click', () => {
        document.querySelector('.mobileMenu-toggle').click();
    });
}

const closeInnerDesktop = document.querySelectorAll(
    '.close-inner-navigation-desktop',
);

for (let i = 0; i < closeInnerDesktop.length; i++) {
    closeInnerDesktop[i].addEventListener('click', () => {
        // shopByCategoriesMega();
        shopByCategoriesMegaDesktop();
    });
}

const shopByBrand = document.getElementById('shopByBrand');
const shopByBrandContent = document.getElementById('navPages-shopbrand');
const shopByWhoWe = document.getElementById('navPages-whoWe-action');
const shopByWhoWeContent = document.getElementById('navPages-whowe');
const shopByCategories = document.getElementById('shopByCategories');
const shopByCategoriesContent = document.getElementById('navPages-categories');

shopByBrand.addEventListener('click', () => {
    brandMegaMenu();
});

shopByWhoWe.addEventListener('click', () => {
    shopByWhoWeMega();
});

shopByCategories.addEventListener('click', () => {
    shopByCategoriesMega();
});

function brandMegaMenu() {
    if (!shopByBrandContent.classList.contains('active')) {
        shopByBrandContent.classList.add('active');
        shopByBrand.setAttribute('aria-expanded', 'true');
        shopByBrandContent.setAttribute('aria-hidden', 'true');
    } else {
        shopByBrandContent.classList.remove('active');
        shopByBrandContent.classList.remove('is-open');
        shopByBrand.classList.remove('is-open');
        shopByBrand.setAttribute('aria-expanded', 'false');
        shopByBrandContent.setAttribute('aria-hidden', 'false');
    }
}

function shopByWhoWeMega() {
    if (!shopByWhoWeContent.classList.contains('active')) {
        shopByWhoWeContent.classList.add('active');
        shopByWhoWe.setAttribute('aria-expanded', 'true');
        shopByWhoWeContent.setAttribute('aria-hidden', 'true');
    } else {
        shopByWhoWeContent.classList.remove('active');
        shopByWhoWeContent.classList.remove('is-open');
        shopByWhoWe.classList.remove('is-open');
        shopByWhoWe.setAttribute('aria-expanded', 'false');
        shopByWhoWeContent.setAttribute('aria-hidden', 'false');
    }
}

function shopByCategoriesMega() {
    if (!shopByCategoriesContent.classList.contains('active')) {
        shopByCategoriesContent.classList.add('active');
        shopByCategories.setAttribute('aria-expanded', 'true');
        shopByCategoriesContent.setAttribute('aria-hidden', 'true');
    } else {
        shopByCategoriesContent.classList.remove('active');
        shopByCategoriesContent.classList.remove('is-open');
        shopByCategories.classList.remove('is-open');
        shopByCategories.setAttribute('aria-expanded', 'false');
        shopByCategoriesContent.setAttribute('aria-hidden', 'false');
    }
}

const iconBackBrandMain = document.getElementById('iconBackBrandMain');
const whoWeContentBack = document.getElementById('whoWeContentBack');
const shopByCategoriesContentBack = document.getElementById(
    'shopByCategoriesContentBack',
);

iconBackBrandMain.addEventListener('click', () => {
    brandMegaMenu();
});

whoWeContentBack.addEventListener('click', () => {
    shopByWhoWeMega();
});

shopByCategoriesContentBack.addEventListener('click', () => {
    shopByCategoriesMega();
});

let navPageSubMenuList = document.querySelectorAll('.test');

const shopByBrandDesktop = document.getElementById('shopByBrandDesktop');
const shopByBrandContentDesktop = document.getElementById(
    'navPages-shopbrand-desktop',
);
const shopByBrandContentDesktopBack = document.getElementById(
    'shopByBrandContentDesktop',
);

console.log(navPageSubMenuList);
for (let i = 0; i < navPageSubMenuList.length; i++) {
    navPageSubMenuList[i].addEventListener('click', (e) => {
        // alert('i clicked');
        document.getElementById('navPages-categories-desktop').scrollIntoView();
        console.log(e.target.parentNode);
        e.preventDefault();
        let parentNode = e.target.parentNode;
        parentNode.children[1].classList.add('active');
        // alert('clicked');
        myFunctionScroll();
        myFunctionScrollMobile();
        shopByBrandContentDesktop.classList.add('overflow-hidden');

        // alert('i clicked');

        // alert('i run');

        // console.log(this);
        // // alert('i clicked');
        // e.target.nextElementSibiling.classList.add('active');
    });
}

let backBtnSub = document.getElementsByClassName('backBtnSub');

for (let i = 0; i < backBtnSub.length; i++) {
    backBtnSub[i].addEventListener('click', (e) => {
        // console.log(e.target.parentNode);
        e.preventDefault();
        let parentNode = e.target.parentNode.parentNode.parentNode;
        console.log(parentNode);
        parentNode.classList.remove('active');
        // console.log(this);
        // // alert('i clicked');
        // e.target.nextElementSibiling.classList.add('active');
    });
}

let brandImg = document.getElementsByClassName('navPages-item-brand--img');
for (let i = 0; i < brandImg.length; i++) {
    // console.log(brandImg[i].src);
    let str = brandImg[i].src;
    const result2 = str.toLowerCase();
    console.log(result2);
}

shopByBrandDesktop.addEventListener('click', (e) => {
    e.preventDefault();
    brandMegaMenuDesktop();
});

shopByBrandContentDesktopBack.addEventListener('click', (e) => {
    e.preventDefault();
    brandMegaMenuDesktop();
});

function brandMegaMenuDesktop() {
    if (!shopByBrandContentDesktop.classList.contains('active')) {
        shopByBrandContentDesktop.classList.add('active');
        shopByBrandDesktop.setAttribute('aria-expanded', 'true');
        shopByBrandContentDesktop.setAttribute('aria-hidden', 'true');
        document.getElementById('backDrop').classList.remove('hidden');
    } else {
        shopByBrandContentDesktop.classList.remove('active');
        shopByBrandContentDesktop.classList.remove('is-open');
        shopByBrandDesktop.classList.remove('is-open');
        shopByBrandDesktop.setAttribute('aria-expanded', 'false');
        shopByBrandContentDesktop.setAttribute('aria-hidden', 'false');
        document.getElementById('backDrop').classList.add('hidden');
    }
}

let closeBrandMenu = document.getElementById('closeBrandMenu');

closeBrandMenu.addEventListener('click', () => {
    brandMegaMenuDesktop();
});

const shopByCategoriesDesktop = document.getElementById(
    'shopByCategoriesDesktop',
);
const shopByCategoriesContentDesktop = document.getElementById(
    'navPages-categories-desktop',
);

const closeCatMenu = document.querySelector('.close-main-menu-cat-desktop');

closeCatMenu.addEventListener('click', () => {
    shopByCategoriesMegaDesktop();
});

shopByCategoriesDesktop.addEventListener('click', (e) => {
    e.preventDefault();
    shopByCategoriesMegaDesktop();
});

function shopByCategoriesMegaDesktop() {
    if (!shopByCategoriesContentDesktop.classList.contains('active')) {
        shopByCategoriesContentDesktop.classList.add('active');
        shopByCategoriesDesktop.setAttribute('aria-expanded', 'true');
        shopByCategoriesContentDesktop.setAttribute('aria-hidden', 'true');
        document.getElementById('backDrop').classList.remove('hidden');
    } else {
        shopByCategoriesContentDesktop.classList.remove('active');
        shopByCategoriesContentDesktop.classList.remove('is-open');
        shopByCategoriesDesktop.classList.remove('is-open');
        shopByCategoriesDesktop.setAttribute('aria-expanded', 'false');
        shopByCategoriesContentDesktop.setAttribute('aria-hidden', 'false');
        document.getElementById('backDrop').classList.add('hidden');
    }
}

const shopByCategoriesContentBackDesktop = document.getElementById(
    'shopByCategoriesContentBackDesktop',
);
shopByCategoriesContentBackDesktop.addEventListener('click', () => {
    shopByCategoriesMegaDesktop();
});

let backDropClick = document.getElementById('backDrop');

backDropClick.addEventListener('click', () => {
    if (shopByCategoriesContentDesktop.classList.contains('active')) {
        shopByCategoriesContentDesktop.classList.remove('active');
        shopByCategoriesContentDesktop.classList.remove('is-open');
        shopByCategoriesDesktop.classList.remove('is-open');
        shopByCategoriesDesktop.setAttribute('aria-expanded', 'false');
        shopByCategoriesContentDesktop.setAttribute('aria-hidden', 'false');
        document.getElementById('backDrop').classList.add('hidden');
    }

    if (shopByBrandContentDesktop.classList.contains('active')) {
        shopByBrandContentDesktop.classList.remove('active');
        shopByBrandContentDesktop.classList.remove('is-open');
        shopByBrandDesktop.classList.remove('is-open');
        shopByBrandDesktop.setAttribute('aria-expanded', 'false');
        shopByBrandContentDesktop.setAttribute('aria-hidden', 'false');
        document.getElementById('backDrop').classList.add('hidden');
    }

    if (shopByWhoWeContentDesktop.classList.contains('active')) {
        shopByWhoWeContentDesktop.classList.remove('active');
        shopByWhoWeContentDesktop.classList.remove('is-open');
        shopByWhoWeDesktop.classList.remove('is-open');
        shopByWhoWeDesktop.setAttribute('aria-expanded', 'false');
        shopByWhoWeContentDesktop.setAttribute('aria-hidden', 'false');
        document.getElementById('backDrop').classList.add('hidden');
    }
});

function myFunctionScroll() {
    const element = document.getElementById('navPages-categories-desktop');
    element.scrollLeft = 0;
    element.scrollTop = 0;
}

function myFunctionScrollMobile() {
    const elementMobile = document.getElementById('navPages-categories');
    elementMobile.scrollLeft = 0;
    elementMobile.scrollTop = 0;
}

const shopByWhoWeDesktop = document.getElementById(
    'navPages-whoWe-action-desktop',
);
const shopByWhoWeContentDesktop = document.getElementById(
    'navPages-whowe-desktop',
);

shopByWhoWeDesktop.addEventListener('click', (e) => {
    e.preventDefault();
    whoWeDesktop();
});

function whoWeDesktop() {
    if (!shopByWhoWeContentDesktop.classList.contains('active')) {
        shopByWhoWeContentDesktop.classList.add('active');
        shopByWhoWeDesktop.setAttribute('aria-expanded', 'true');
        shopByWhoWeContentDesktop.setAttribute('aria-hidden', 'true');
        document.getElementById('backDrop').classList.remove('hidden');
    } else {
        shopByWhoWeContentDesktop.classList.remove('active');
        shopByWhoWeContentDesktop.classList.remove('is-open');
        shopByWhoWeDesktop.classList.remove('is-open');
        shopByWhoWeDesktop.setAttribute('aria-expanded', 'false');
        shopByWhoWeContentDesktop.setAttribute('aria-hidden', 'false');
        document.getElementById('backDrop').classList.add('hidden');
    }
}

const closeWhoWeDesktop = document.getElementById('close-whowe-desktop');
const whoWeDesktopBack = document.getElementById('whoWeContentBackDesktop');

closeWhoWeDesktop.addEventListener('click', () => {
    whoWeDesktop();
});

whoWeDesktopBack.addEventListener('click', () => {
    whoWeDesktop();
});

const accountDropdown = document.getElementById('accountDropdown');

if (accountDropdown) {
    const accountDropdownContent = document.getElementById(
        'accountDropdownContent',
    );
    const fixedAccountBg = document.getElementById('fixedAccountBg');
    accountDropdown.addEventListener('click', (e) => {
        e.preventDefault();
        accountDesktopNav();
    });

    fixedAccountBg.addEventListener('click', () => {
        accountDesktopNav();
    });

    function accountDesktopNav() {
        if (!accountDropdownContent.classList.contains('active')) {
            accountDropdownContent.classList.add('active');
            fixedAccountBg.classList.add('active');
        } else {
            accountDropdownContent.classList.remove('active');
            fixedAccountBg.classList.remove('active');
        }
    }
}

// backBtnSub.addEventListener('click', () => {
//     alert('hello');
// });
// console.log(backBtnSub);
// for (let i = 0; i < backBtnSub[i].length; i++) {
//     console.log('mac ' + backBtnSub[i]);
// backBtnSub[i].addEventListener('click', (e) => {
//     console.log('clicked');
// });
// }

/*
 * Create a new MobileMenuToggle instance
 * @param {string} [selector]
 * @param {Object} [options]
 * @param {Object} [options.headerSelector]
 * @param {Object} [options.menuSelector]
 * @param {Object} [options.scrollViewSelector]
 * @return {MobileMenuToggle}
 */
export default function mobileMenuToggleFactory(
    selector = `[data-${PLUGIN_KEY.SNAKE}]`,
    overrideOptions = {},
) {
    const $toggle = $(selector).eq(0);
    const instanceKey = `${PLUGIN_KEY.CAMEL}Instance`;
    const cachedMobileMenu = $toggle.data(instanceKey);

    if (cachedMobileMenu instanceof MobileMenuToggle) {
        return cachedMobileMenu;
    }

    const options = _.extend(optionsFromData($toggle), overrideOptions);
    const mobileMenu = new MobileMenuToggle($toggle, options);

    $toggle.data(instanceKey, mobileMenu);

    return mobileMenu;
}
